import React from "react";
import { GoBack } from "../../../components/Layout/GoBack";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Refer = () => {
  const websiteURL = "https://mecglobal.cc/signup";

  const { user } = useSelector((state) => {
    const { user, token } = state.userData;

    return {
      user,
    };
  });

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${websiteURL}${user.referralLink}`);

    toast.success("Referral link copied", {
      duration: 3000,
      position: "bottom-center",
    });
  };

  return (
    <div>
      <div className="container px-4 py-8 max-w-sm mx-auto relative h-screen">
        <GoBack />
        <h2 className="font-body font-bold text-3xl mt-3">Refer</h2>

        <p className="text-sm font-body text-textGray mt-5">
          Our referral are structured in three level
        </p>
        <p className="text-sm font-body text-textGray mt-5">
          10% reward for 1st level
        </p>
        <p className="text-sm font-body text-textGray mt-1">
          5% reward for 2nd level
        </p>
        <p className="text-sm font-body text-textGray mt-1">
          3% reward for 3rd level
        </p>

        <div className="mt-6 bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-body text-textGray font-semibold mb-3">
            Special Rewards Program:
          </p>
          <p className="text-xs font-body text-textGray mb-2">
            • 20 active members: Monthly salary + surprise package
          </p>
          <p className="text-xs font-body text-textGray mb-2">
            • 50 active members: $10,000 monthly award + vacation
          </p>
          <p className="text-xs font-body text-textGray mb-2">
            • 100 active members: $50,000 + ambassadorship
          </p>
          <p className="text-xs font-body text-textGray font-semibold">
            Where you become MecGlobal shareholders
          </p>
        </div>

        <p className="text-sm font-body text-textGray mt-5">
          Refer and start earning
        </p>

        <div className="mt-4">
          <p className="text-fadedGray text-sm font-body font-light">
            Referral link:
          </p>
          <div onClick={() => copyToClipboard()} className="flex gap-x-2 ">
            <p className=" text-xs font-body ">
              {websiteURL}
              {user.referralLink}
            </p>
            <img className="" src="/img/icons/copy.svg" />
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-y-2">
          <div className="flex justify-between items-center">
            <p className="text-fadedGray text-sm font-body font-light">
              Referral Count
            </p>
            <p className="font-body text-md ">{user.referralCount}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;
